module.exports = {
  context: {
    team: [
      {
        hash: 'abc123',
        image: {
          thumbnail: 'https://via.placeholder.com/300',
          src: 'https://via.placeholder.com/600',
          alt: 'lorem ipsum dolor sit amet',
          lazy: true,
          width: 600,
          height: 600
        },
        heading: 'First Name Last Name',
        title: 'Title',
        date: 'Joined in 1994',
        text: '<p>I joined the Board when I was referred by a Board Member. I reviewed CCC’s accomplishments and felt that my background in financial investments and clinical psychology could benefit this organization. It would also allow me to learn about the process and benefits of being part of a dynamic non-profit. The benefits this organization has brought to me would to be part of a team with unending dedication to their clients, to the good of their communities they serve and caring for humanity.</p><p>Mr. Jenkins and his executive team have created an environment of positive, focused leadership. They have selected each of the Board Members with a purpose of expertise, but in my opinion all members share the same focus to help CCC to the best of their ability and to have fun providing that service to them. Thank you CCC!</p>',
        button: 'Bio'
      },
      {
        hash: 'abc124',
        image: {
          thumbnail: 'https://via.placeholder.com/300',
          src: 'https://via.placeholder.com/600',
          alt: 'lorem ipsum dolor sit amet',
          lazy: true,
          width: 600,
          height: 600
        },
        heading: 'First Name Last Name',
        title: 'Title',
        date: 'Joined in 1994',
        text: '<p>I joined the Board when I was referred by a Board Member. I reviewed CCC’s accomplishments and felt that my background in financial investments and clinical psychology could benefit this organization. It would also allow me to learn about the process and benefits of being part of a dynamic non-profit. The benefits this organization has brought to me would to be part of a team with unending dedication to their clients, to the good of their communities they serve and caring for humanity.</p><p>Mr. Jenkins and his executive team have created an environment of positive, focused leadership. They have selected each of the Board Members with a purpose of expertise, but in my opinion all members share the same focus to help CCC to the best of their ability and to have fun providing that service to them. Thank you CCC!</p>',
        button: 'Bio'
      },
      {
        hash: 'abc125',
        image: {
          thumbnail: 'https://via.placeholder.com/300',
          src: 'https://via.placeholder.com/600',
          alt: 'lorem ipsum dolor sit amet',
          lazy: true,
          width: 600,
          height: 600
        },
        heading: 'First Name Last Name',
        title: 'Title',
        date: 'Joined in 1994',
        text: '<p>I joined the Board when I was referred by a Board Member. I reviewed CCC’s accomplishments and felt that my background in financial investments and clinical psychology could benefit this organization. It would also allow me to learn about the process and benefits of being part of a dynamic non-profit. The benefits this organization has brought to me would to be part of a team with unending dedication to their clients, to the good of their communities they serve and caring for humanity.</p><p>Mr. Jenkins and his executive team have created an environment of positive, focused leadership. They have selected each of the Board Members with a purpose of expertise, but in my opinion all members share the same focus to help CCC to the best of their ability and to have fun providing that service to them. Thank you CCC!</p>',
        button: 'Bio'
      },
      {
        hash: 'abc126',
        image: {
          thumbnail: 'https://via.placeholder.com/300',
          src: 'https://via.placeholder.com/600',
          alt: 'lorem ipsum dolor sit amet',
          lazy: true,
          width: 600,
          height: 600
        },
        heading: 'First Name Last Name',
        title: 'Title',
        date: 'Joined in 1994',
        text: '<p>I joined the Board when I was referred by a Board Member. I reviewed CCC’s accomplishments and felt that my background in financial investments and clinical psychology could benefit this organization. It would also allow me to learn about the process and benefits of being part of a dynamic non-profit. The benefits this organization has brought to me would to be part of a team with unending dedication to their clients, to the good of their communities they serve and caring for humanity.</p><p>Mr. Jenkins and his executive team have created an environment of positive, focused leadership. They have selected each of the Board Members with a purpose of expertise, but in my opinion all members share the same focus to help CCC to the best of their ability and to have fun providing that service to them. Thank you CCC!</p>',
        button: 'Bio'
      },
      {
        hash: 'abc127',
        image: {
          thumbnail: 'https://via.placeholder.com/300',
          src: 'https://via.placeholder.com/600',
          alt: 'lorem ipsum dolor sit amet',
          lazy: true,
          width: 600,
          height: 600
        },
        heading: 'First Name Last Name',
        title: 'Title',
        date: 'Joined in 1994',
        text: '<p>I joined the Board when I was referred by a Board Member. I reviewed CCC’s accomplishments and felt that my background in financial investments and clinical psychology could benefit this organization. It would also allow me to learn about the process and benefits of being part of a dynamic non-profit. The benefits this organization has brought to me would to be part of a team with unending dedication to their clients, to the good of their communities they serve and caring for humanity.</p><p>Mr. Jenkins and his executive team have created an environment of positive, focused leadership. They have selected each of the Board Members with a purpose of expertise, but in my opinion all members share the same focus to help CCC to the best of their ability and to have fun providing that service to them. Thank you CCC!</p>',
        button: 'Bio'
      },
      {
        hash: 'abc128',
        image: {
          thumbnail: 'https://via.placeholder.com/300',
          src: 'https://via.placeholder.com/600',
          alt: 'lorem ipsum dolor sit amet',
          lazy: true,
          width: 600,
          height: 600
        },
        heading: 'First Name Last Name',
        title: 'Title',
        date: 'Joined in 1994',
        text: '<p>I joined the Board when I was referred by a Board Member. I reviewed CCC’s accomplishments and felt that my background in financial investments and clinical psychology could benefit this organization. It would also allow me to learn about the process and benefits of being part of a dynamic non-profit. The benefits this organization has brought to me would to be part of a team with unending dedication to their clients, to the good of their communities they serve and caring for humanity.</p><p>Mr. Jenkins and his executive team have created an environment of positive, focused leadership. They have selected each of the Board Members with a purpose of expertise, but in my opinion all members share the same focus to help CCC to the best of their ability and to have fun providing that service to them. Thank you CCC!</p>',
        button: 'Bio'
      },
      {
        hash: 'abc129',
        image: {
          thumbnail: 'https://via.placeholder.com/300',
          src: 'https://via.placeholder.com/600',
          alt: 'lorem ipsum dolor sit amet',
          lazy: true,
          width: 600,
          height: 600
        },
        heading: 'First Name Last Name',
        title: 'Title',
        date: 'Joined in 1994',
        text: '<p>I joined the Board when I was referred by a Board Member. I reviewed CCC’s accomplishments and felt that my background in financial investments and clinical psychology could benefit this organization. It would also allow me to learn about the process and benefits of being part of a dynamic non-profit. The benefits this organization has brought to me would to be part of a team with unending dedication to their clients, to the good of their communities they serve and caring for humanity.</p><p>Mr. Jenkins and his executive team have created an environment of positive, focused leadership. They have selected each of the Board Members with a purpose of expertise, but in my opinion all members share the same focus to help CCC to the best of their ability and to have fun providing that service to them. Thank you CCC!</p>',
        button: 'Bio'
      },
      {
        hash: 'abc1210',
        image: {
          thumbnail: 'https://via.placeholder.com/300',
          src: 'https://via.placeholder.com/600',
          alt: 'lorem ipsum dolor sit amet',
          lazy: true,
          width: 600,
          height: 600
        },
        heading: 'First Name Last Name',
        title: 'Title',
        date: 'Joined in 1994',
        text: '<p>I joined the Board when I was referred by a Board Member. I reviewed CCC’s accomplishments and felt that my background in financial investments and clinical psychology could benefit this organization. It would also allow me to learn about the process and benefits of being part of a dynamic non-profit. The benefits this organization has brought to me would to be part of a team with unending dedication to their clients, to the good of their communities they serve and caring for humanity.</p><p>Mr. Jenkins and his executive team have created an environment of positive, focused leadership. They have selected each of the Board Members with a purpose of expertise, but in my opinion all members share the same focus to help CCC to the best of their ability and to have fun providing that service to them. Thank you CCC!</p>',
        button: 'Bio'
      },
      {
        hash: 'abc1211',
        image: {
          thumbnail: 'https://via.placeholder.com/300',
          src: 'https://via.placeholder.com/600',
          alt: 'lorem ipsum dolor sit amet',
          lazy: true,
          width: 600,
          height: 600
        },
        heading: 'First Name Last Name',
        title: 'Title',
        date: 'Joined in 1994',
        text: '<p>I joined the Board when I was referred by a Board Member. I reviewed CCC’s accomplishments and felt that my background in financial investments and clinical psychology could benefit this organization. It would also allow me to learn about the process and benefits of being part of a dynamic non-profit. The benefits this organization has brought to me would to be part of a team with unending dedication to their clients, to the good of their communities they serve and caring for humanity.</p><p>Mr. Jenkins and his executive team have created an environment of positive, focused leadership. They have selected each of the Board Members with a purpose of expertise, but in my opinion all members share the same focus to help CCC to the best of their ability and to have fun providing that service to them. Thank you CCC!</p>',
        button: 'Bio'
      },
      {
        hash: 'abc1212',
        image: {
          thumbnail: 'https://via.placeholder.com/300',
          src: 'https://via.placeholder.com/600',
          alt: 'lorem ipsum dolor sit amet',
          lazy: true,
          width: 600,
          height: 600
        },
        heading: 'First Name Last Name',
        title: 'Title',
        date: 'Joined in 1994',
        text: '<p>I joined the Board when I was referred by a Board Member. I reviewed CCC’s accomplishments and felt that my background in financial investments and clinical psychology could benefit this organization. It would also allow me to learn about the process and benefits of being part of a dynamic non-profit. The benefits this organization has brought to me would to be part of a team with unending dedication to their clients, to the good of their communities they serve and caring for humanity.</p><p>Mr. Jenkins and his executive team have created an environment of positive, focused leadership. They have selected each of the Board Members with a purpose of expertise, but in my opinion all members share the same focus to help CCC to the best of their ability and to have fun providing that service to them. Thank you CCC!</p>',
        button: 'Bio'
      },
      {
        hash: 'abc1213',
        image: {
          thumbnail: 'https://via.placeholder.com/300',
          src: 'https://via.placeholder.com/600',
          alt: 'lorem ipsum dolor sit amet',
          lazy: true,
          width: 600,
          height: 600
        },
        heading: 'First Name Last Name',
        title: 'Title',
        date: 'Joined in 1994',
        text: '<p>I joined the Board when I was referred by a Board Member. I reviewed CCC’s accomplishments and felt that my background in financial investments and clinical psychology could benefit this organization. It would also allow me to learn about the process and benefits of being part of a dynamic non-profit. The benefits this organization has brought to me would to be part of a team with unending dedication to their clients, to the good of their communities they serve and caring for humanity.</p><p>Mr. Jenkins and his executive team have created an environment of positive, focused leadership. They have selected each of the Board Members with a purpose of expertise, but in my opinion all members share the same focus to help CCC to the best of their ability and to have fun providing that service to them. Thank you CCC!</p>',
        button: 'Bio'
      },
      {
        hash: 'abc1214',
        image: {
          thumbnail: 'https://via.placeholder.com/300',
          src: 'https://via.placeholder.com/600',
          alt: 'lorem ipsum dolor sit amet',
          lazy: true,
          width: 600,
          height: 600
        },
        heading: 'First Name Last Name',
        title: 'Title',
        date: 'Joined in 1994',
        text: '<p>I joined the Board when I was referred by a Board Member. I reviewed CCC’s accomplishments and felt that my background in financial investments and clinical psychology could benefit this organization. It would also allow me to learn about the process and benefits of being part of a dynamic non-profit. The benefits this organization has brought to me would to be part of a team with unending dedication to their clients, to the good of their communities they serve and caring for humanity.</p><p>Mr. Jenkins and his executive team have created an environment of positive, focused leadership. They have selected each of the Board Members with a purpose of expertise, but in my opinion all members share the same focus to help CCC to the best of their ability and to have fun providing that service to them. Thank you CCC!</p>',
        button: 'Bio'
      }
    ],
    sectionHeading: 'Executive Leadership'
  }
}
